import { useEffect, useState } from 'react'

import { createPortal } from 'react-dom'

import { SIDE_CONTENT_PORTAL_ID } from './CorePage'

type Props = {
  children: React.ReactNode
}

export const CorePageSidePortal: React.FC<Props> = ({ children }) => {
  const [domIsReady, setDomIsReady] = useState(false)

  useEffect(() => {
    setDomIsReady(true) // wait for DOM to load before looking for the portal
  }, [])

  if (!domIsReady) return null

  const portal = document.getElementById(SIDE_CONTENT_PORTAL_ID)

  if (!portal) return null

  return createPortal(children, portal)
}
